import React from 'react';

export const LogoTwitter = () => (
    <svg
        width="24px"
        height="20px"
        viewBox="0 0 24 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Twitter icon</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-1068.000000, -611.000000)" fill="#FFFFFF">
                <g>
                    <g transform="translate(120.000000, 593.000000)">
                        <g transform="translate(812.000000, 12.000000)">
                            <g transform="translate(132.000000, 0.000000)">
                                <g>
                                    <path d="M5.5225,7.5132668 C4.4485,9.8427668 4.939,12.0942668 6.799,13.8372668 C6.1525,13.6647668 5.5045,13.4937668 4.858,13.3212668 C4.978,15.5982668 6.457,17.1612668 8.491,18.0117668 L6.5965,18.0117668 C7.4185,19.9752668 9.0895,21.0267668 11.1625,21.2907668 C9.0505,22.7862668 6.5635,23.3622668 4,23.2452668 C9.1045,26.3742668 16.0255,25.9032668 20.68,22.1502668 C22.627,20.5797668 24.1195,18.4842668 24.9325,16.1172668 C25.3495,14.9007668 25.5475,13.6572668 25.6255,12.3792668 C25.717,10.8777668 26.9605,10.1412668 28,9.1317668 C27.7135,8.8317668 25.8355,9.5367668 25.45,9.6327668 C26.1205,8.9697668 27.1585,8.2137668 27.244,7.1922668 C26.5405,7.4412668 25.735,7.8657668 25.0075,7.9887668 C24.1735,8.1297668 23.8345,7.7067668 23.1475,7.3197668 C22.0945,6.7287668 20.848,6.5322668 19.6645,6.7572668 C16.6645,7.3257668 15.8305,9.7392668 15.6625,12.4362668 C11.7205,12.1707668 8.1895,10.4172668 5.5225,7.5132668 C4.375,10.0002668 8.284,10.5192668 5.5225,7.5132668" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
